import { render, staticRenderFns } from "./Dash-activity-body.vue?vue&type=template&id=09eed3e5"
import script from "./Dash-activity-body.vue?vue&type=script&lang=js"
export * from "./Dash-activity-body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports